import * as Plate from '@udecode/plate';
import { GenerateContentElement } from '../nodes/GenerateContentElement';

export function unwrapGeneratedContent({ editor }) {
  Plate.unwrapNodes(editor, {
    at: [],
    match: (n) => GenerateContentElement.is(n),
  });

  editor.hasGeneratedContent = false;
}
